/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ImportCellInfoFromJSON, ImportCellInfoToJSON } from './';
export function ImportCommitReportFromJSON(json) {
    return ImportCommitReportFromJSONTyped(json, false);
}
export function ImportCommitReportFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        importedCells: json['importedCells'].map(ImportCellInfoFromJSON),
    };
}
export function ImportCommitReportToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        importedCells: value.importedCells.map(ImportCellInfoToJSON),
    };
}
